import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  Typography
} from '@mui/material';
import { schemesV2Utils } from '../../services/schemesV2Api';

const PaymentScheduleTable = ({ paymentSchedule, currentEnrollment, selectedScheme }) => {

  const getStatusChip = (status) => {
    const colors = {
      paid: { bg: '#4caf50', color: 'white' },
      next: { bg: '#ff9800', color: 'white' },
      pending: { bg: '#e0e0e0', color: '#666' }
    };
    return (
      <Chip
        label={status.charAt(0).toUpperCase() + status.slice(1)}
        size="small"
        sx={{
          backgroundColor: colors[status]?.bg || colors.pending.bg,
          color: colors[status]?.color || colors.pending.color,
          fontWeight: 600,
          fontSize: "12px"
        }}
      />
    );
  };
  
  const isAccumulationScheme = currentEnrollment?.scheme_id === '10-month-accumulation';

  let gramsPerInstallment = 0;
  if (isAccumulationScheme) {
    const periodsPaid = currentEnrollment?.plan_progress?.periods_paid || 0;
    const totalGrams = currentEnrollment?.gold_grams_accumulated || 0;
    gramsPerInstallment = periodsPaid > 0 ? totalGrams / periodsPaid : 0;
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontFamily: '"Roboto", sans-serif' }}>
        Payment Schedule
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: '"Roboto", sans-serif' }}>
        {currentEnrollment ? 'Your payment schedule for this enrollment' : 'Payment schedule will be available after enrollment'}
      </Typography>
      
      <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>#</TableCell>
              <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>Due date</TableCell>
              <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>Payment date</TableCell>
              <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>Amount</TableCell>
              <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>Status</TableCell>
              
              {isAccumulationScheme && (
                <>
                  <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>
                    Accumulated {selectedScheme?.metal?.toLowerCase() === 'silver' ? 'Silver' : 'Gold'} ({selectedScheme?.purity || '22KT'})
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, fontFamily: '"Roboto", sans-serif' }}>
                    {selectedScheme?.metal?.toLowerCase() === 'silver' ? 'Silver' : 'Gold'} Rate (On Payment Day) ({selectedScheme?.purity || '22KT'})
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {paymentSchedule.length > 0 ? (
              paymentSchedule.map((payment) => {
                console.log("payment", payment);
                let goldRate = 0;
                if (isAccumulationScheme && payment.status === 'paid' && gramsPerInstallment > 0) {
                  goldRate = payment.amount / gramsPerInstallment;
                }

                return (
                  <TableRow key={payment.installmentNumber}>
                    <TableCell sx={{ fontFamily: '"Roboto", sans-serif' }}>{payment.installmentNumber}</TableCell>
                    <TableCell sx={{ fontFamily: '"Roboto", sans-serif' }}>{payment.dueDate}</TableCell>
                    <TableCell sx={{ fontFamily: '"Roboto", sans-serif' }}>
                      {payment.paymentDate ? schemesV2Utils.formatDate(payment.paymentDate) : payment.payment_date ? schemesV2Utils.formatDate(payment.payment_date) : '-'}
                    </TableCell>
                    <TableCell sx={{ fontFamily: '"Roboto", sans-serif' }}>₹{payment.amount.toLocaleString()}</TableCell>
                    <TableCell>
                      {getStatusChip(payment.status)}
                    </TableCell>

                    {isAccumulationScheme && (
                      <>
                        <TableCell sx={{ fontFamily: '"Roboto", sans-serif', fontWeight: 600, color: '#A36E29' }}>
                          {payment.status === 'paid' ? parseFloat(payment.goldGramsCredited).toFixed(3) : '-'}
                        </TableCell>
                        <TableCell sx={{ fontFamily: '"Roboto", sans-serif' }}>
                          {payment.status === 'paid' ? parseFloat(payment.goldRate).toFixed(2) : '-'}
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={isAccumulationScheme ? 7 : 5} sx={{ textAlign: 'center', fontFamily: '"Roboto", sans-serif' }}>
                  {currentEnrollment ? 'Generating payment schedule...' : 'Loading payment schedule...'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PaymentScheduleTable;